<template>
  <v-app-bar app flat height="64" class="app-bar" color="transparent">
    <v-app-bar-nav-icon class="app-bar__icon" @click.stop="expand" />

    <h4 class="app-bar__title">
      {{ profile && profile.organizationName ? profile.organizationName : "Admin Portal" }}
    </h4>

    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="app-bar__icon mr-1"
          v-bind="attrs"
          v-on="on"
          @click="toggleTheme"
        >
          <v-icon>{{ isDark ? "mdi-white-balance-sunny" : "mdi-weather-night" }}</v-icon>
        </v-btn>
      </template>
      <span>{{ isDark ? "Light mode" : "Dark mode" }}</span>
    </v-tooltip>

    <v-menu
      offset-y
      left
      min-width="220"
      transition="slide-y-transition"
      content-class="app-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text class="app-bar__profile" v-bind="attrs" v-on="on">
          <v-avatar size="34" color="var(--signal-soft)" class="app-bar__avatar">
            <span class="app-bar__initials">{{ initials }}</span>
          </v-avatar>
          <span class="app-bar__name d-none d-sm-inline">{{
            profile && profile.name ? profile.name : "Account"
          }}</span>
          <v-icon small class="app-bar__caret d-none d-sm-inline">mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list class="app-menu__list" dense>
        <div class="app-menu__header">
          <p class="app-menu__header-name">
            {{ profile && profile.name ? profile.name : "Account" }}
          </p>
          <p v-if="profile && profile.phone" class="app-menu__header-sub">
            {{ profile.phone }}
          </p>
        </div>
        <v-divider />
        <v-list-item
          v-for="(option, idx) in options"
          :key="idx"
          @click="state(option.slug)"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>{{ option.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ option.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "Appbar",
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    options: [{ title: "Logout", slug: "logout", icon: "mdi-logout" }]
  }),
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    initials() {
      const name = this.profile && this.profile.name ? this.profile.name : "";
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return "A";
      return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
    }
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem(
        "cua.theme",
        this.$vuetify.theme.dark ? "dark" : "light"
      );
    },
    state(value) {
      if (value === "logout") this.logout();
    },
    expand() {
      this.$emit("toggle");
    },
    logout() {
      this.$store.dispatch("auth/logOut");
    }
  }
};
</script>

<style scoped>
.app-bar {
  background: var(--card) !important;
  border-bottom: 1px solid var(--border);
}
.app-bar__icon {
  color: var(--muted-foreground) !important;
}
.app-bar__title {
  font-family: var(--font-heading);
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--foreground);
  margin-left: 4px;
}
.app-bar__profile {
  height: 44px !important;
  text-transform: none;
  letter-spacing: normal;
  padding: 0 8px !important;
  border-radius: var(--radius);
}
.app-bar__avatar {
  border: 1px solid var(--border);
}
.app-bar__initials {
  font-size: 13px;
  font-weight: 600;
  color: var(--signal);
}
.app-bar__name {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--foreground);
}
.app-bar__caret {
  margin-left: 2px;
  color: var(--muted-foreground);
}
</style>
